import { render } from "./SellsyAILoader.vue?vue&type=template&id=01f7f99d&scoped=true"
import script from "./SellsyAILoader.vue?vue&type=script&lang=js"
export * from "./SellsyAILoader.vue?vue&type=script&lang=js"

import "./SellsyAILoader.vue?vue&type=style&index=0&id=01f7f99d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f7f99d"]])

export default __exports__